/* Seeds de analítica. Tres shapes distintos según el endpoint que la página llama. */

function lastNDays(n: number): string[] {
  const out: string[] = []
  for (let i = n - 1; i >= 0; i--) {
    const d = new Date()
    d.setDate(d.getDate() - i)
    out.push(d.toISOString().slice(0, 10))
  }
  return out
}

// /api/v1/analytics/overview?days=N — visit data agregada
export const ANALYTICS_OVERVIEW_DEMO = {
  totals: {
    pageviews: 18_412,
    visitors: 6_240,
    sessions: 9_180,
    bounceRate: 0.42,
    avgPagesPerSession: 2.1,
  },
  timeseries: lastNDays(30).map((date, i) => ({
    date,
    pageviews: Math.round(450 + 180 * Math.sin(i / 3) + Math.random() * 200),
    visitors: Math.round(160 + 60 * Math.sin(i / 4) + Math.random() * 80),
  })),
  topReferrers: [
    { host: 'instagram.com',   pageviews: 4_120 },
    { host: 'google.com',      pageviews: 3_680 },
    { host: 'direct',          pageviews: 3_204 },
    { host: 'tiktok.com',      pageviews: 1_980 },
    { host: 'facebook.com',    pageviews:   712 },
    { host: 'l.instagram.com', pageviews:   468 },
    { host: 'x.com',           pageviews:   324 },
  ],
  topPages: [
    { path: '/',                                pageviews: 6_412 },
    { path: '/catalogo',                        pageviews: 3_980 },
    { path: '/producto/long-sleeve-somnolencia', pageviews: 2_140 },
    { path: '/producto/hoodie-manzana-de-eva',  pageviews: 1_768 },
    { path: '/producto/tracksuit-osmosis',      pageviews: 1_220 },
    { path: '/checkout',                        pageviews:   892 },
    { path: '/seguimiento',                     pageviews:   456 },
  ],
  countries: [
    { country: 'CO', pageviews: 14_120 },
    { country: 'US', pageviews:  1_840 },
    { country: 'MX', pageviews:    864 },
    { country: 'AR', pageviews:    520 },
    { country: 'PE', pageviews:    412 },
    { country: 'CL', pageviews:    312 },
    { country: 'EC', pageviews:    248 },
    { country: 'ES', pageviews:     96 },
  ],
  devices: [
    { device: 'mobile',  pageviews: 12_840 },
    { device: 'desktop', pageviews:  4_980 },
    { device: 'tablet',  pageviews:    412 },
    { device: 'bot',     pageviews:    180 },
  ],
  browsers: [
    { browser: 'Chrome',  pageviews: 11_340 },
    { browser: 'Safari',  pageviews:  4_812 },
    { browser: 'Firefox', pageviews:  1_120 },
    { browser: 'Edge',    pageviews:    640 },
    { browser: 'Otros',   pageviews:    500 },
  ],
}

// /api/admin/tenants/:id/analytics?period=day|week|month|year — dashboard del store
//
// `popularProducts` matchea con los IDs reales del seed `products.ts`.

const DAY_LABELS  = ['06:00', '09:00', '12:00', '15:00', '18:00', '21:00']
const WEEK_LABELS = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom']
const MONTH_LABELS = ['Sem 1', 'Sem 2', 'Sem 3', 'Sem 4']
const YEAR_LABELS = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']

function curve(labels: string[], peakActual: number, peakPrev: number): Array<{ name: string; actual: number; previous: number }> {
  return labels.map((name, i) => {
    const wave = Math.sin((i / labels.length) * Math.PI * 1.4)
    const noise = (Math.random() - 0.5) * 0.25
    return {
      name,
      actual:   Math.max(0, Math.round(peakActual * (0.5 + wave * 0.5 + noise))),
      previous: Math.max(0, Math.round(peakPrev   * (0.5 + wave * 0.4 + noise * 0.8))),
    }
  })
}

function sessionsCurve(labels: string[], peak: number): Array<{ name: string; value: number }> {
  return labels.map((name, i) => {
    const wave = Math.sin((i / labels.length) * Math.PI)
    const noise = (Math.random() - 0.3) * 0.4
    return { name, value: Math.max(0, Math.round(peak * (0.4 + wave * 0.6 + noise))) }
  })
}

function tenantAnalyticsFor(period: 'day' | 'week' | 'month' | 'year') {
  const presets = {
    day:   { labels: DAY_LABELS,   revPeak: 320_000,   prevPeak: 280_000,   ordersPeak: 5,   prevOrdersPeak: 4,   sessionsPeak: 180,   totalOrders: 14,  totalRevenue:   840_000 },
    week:  { labels: WEEK_LABELS,  revPeak: 4_200_000, prevPeak: 3_600_000, ordersPeak: 18,  prevOrdersPeak: 14,  sessionsPeak: 850,   totalOrders: 87,  totalRevenue: 18_640_000 },
    month: { labels: MONTH_LABELS, revPeak: 7_800_000, prevPeak: 6_900_000, ordersPeak: 32,  prevOrdersPeak: 26,  sessionsPeak: 2_400, totalOrders: 312, totalRevenue: 78_120_000 },
    year:  { labels: YEAR_LABELS,  revPeak: 9_200_000, prevPeak: 8_100_000, ordersPeak: 76,  prevOrdersPeak: 62,  sessionsPeak: 6_800, totalOrders: 1_840, totalRevenue: 412_800_000 },
  }
  const p = presets[period]
  const totalRevDelta = period === 'day' ? 6.8 : period === 'week' ? 14.2 : period === 'month' ? 21.5 : 38.4
  const totalOrdersDelta = period === 'day' ? 4.1 : period === 'week' ? 21.0 : period === 'month' ? 18.2 : 32.1

  return {
    period,
    from: '2026-04-01',
    to: '2026-05-09',
    kpis: {
      totalRevenue: p.totalRevenue,
      totalRevenueDeltaPct: totalRevDelta,
      totalOrders: p.totalOrders,
      totalOrdersDeltaPct: totalOrdersDelta,
      avgOrderValue: p.totalOrders > 0 ? Math.round(p.totalRevenue / p.totalOrders) : 0,
      avgOrderValueDeltaPct: -3.4,
      avgIncome: Math.round(p.totalRevenue / Math.max(1, p.labels.length)),
      avgIncomeDeltaPct: 7.2,
    },
    revenueChart: curve(p.labels, p.revPeak, p.prevPeak),
    ordersChart:  curve(p.labels, p.ordersPeak, p.prevOrdersPeak),
    sessionsChart: sessionsCurve(p.labels, p.sessionsPeak),
    // Match con los IDs reales del seed `products.ts`.
    popularProducts: [
      { id: 'prd_02', name: 'Long Sleeve "Somnolencia"',   sales: Math.round(p.totalOrders * 0.32) },
      { id: 'prd_03', name: 'Tracksuit "Ósmosis"',          sales: Math.round(p.totalOrders * 0.21) },
      { id: 'prd_01', name: 'Hoodie "La Manzana de Eva"',   sales: Math.round(p.totalOrders * 0.18) },
      { id: 'prd_06', name: 'Cap "Última Cena"',            sales: Math.round(p.totalOrders * 0.14) },
      { id: 'prd_04', name: 'Camiseta "Anestesia"',         sales: Math.round(p.totalOrders * 0.10) },
    ],
  }
}

export const TENANT_ANALYTICS_DEMO = {
  forPeriod: tenantAnalyticsFor,
}

// /api/admin/tenants/:id/usage — uso vs límites del plan
export const TENANT_USAGE_DEMO = {
  period: '2026-05',
  plan: 'pro',
  usage: {
    apiRequests:  { used: 124_500, max: 500_000, pct: 0.249 },
    orders:       { used:      87, max:   1_000, pct: 0.087 },
    bandwidthGB:  { used:    12.4, max:    50.0, pct: 0.248 },
    storageGB:    { used:     2.8, max:    20.0, pct: 0.140 },
  },
}

// /api/v1/analytics/snippet — snippet HTML para que el storefront mande pageviews
export const ANALYTICS_SNIPPET_DEMO = {
  tenantId: 'tnt_demo',
  apiUrl: 'https://api.demo.core-admin.live',
  snippet: `<!-- Centrio Studios — analytics tracker -->
<script>
  window.coreAnalytics = {
    tenantId: 'tnt_demo',
    apiUrl: 'https://api.demo.core-admin.live',
  };
</script>
<script async src="https://cdn.core-admin.live/track.js"></script>`,
}

// Backward-compat: dashboard / reports siguen leyendo este shape "viejo".
export const ANALYTICS_DEMO = {
  summary: {
    revenue30d: 18_640_000, revenue30dDelta: 0.142,
    orders30d: 87, orders30dDelta: 0.21,
    customers30d: 64, customers30dDelta: 0.09,
    avgTicket: 214_252, avgTicketDelta: -0.04,
    conversion: 0.024, conversionDelta: 0.003,
    sessions30d: 3_612, sessionsDelta: 0.35,
  },
  revenueByDay: lastNDays(30).map((date, i) => ({
    date,
    revenue: Math.round(400_000 + 200_000 * Math.sin(i / 3) + Math.random() * 300_000),
    orders: Math.round(2 + Math.abs(Math.sin(i / 2)) * 6),
  })),
  sessionsByDay: lastNDays(30).map((date, i) => ({
    date,
    sessions: Math.round(60 + 30 * Math.sin(i / 4) + Math.random() * 70),
  })),
  topProducts: [
    { id: 'prd_02', name: 'Long Sleeve "Somnolencia"', units: 67, revenue: 16_080_000 },
    { id: 'prd_03', name: 'Tracksuit "Ósmosis"',       units: 18, revenue: 7_740_000 },
    { id: 'prd_01', name: 'Hoodie "La Manzana de Eva"', units: 22, revenue: 6_490_000 },
    { id: 'prd_04', name: 'Camiseta "Anestesia"',      units: 12, revenue: 2_340_000 },
    { id: 'prd_06', name: 'Cap "Última Cena"',         units: 19, revenue: 1_805_000 },
  ],
  trafficSources: [
    { source: 'Direct',     sessions: 1_240, percentage: 34 },
    { source: 'Instagram',  sessions: 1_086, percentage: 30 },
    { source: 'Google',     sessions:   724, percentage: 20 },
    { source: 'TikTok',     sessions:   362, percentage: 10 },
    { source: 'Otros',      sessions:   200, percentage:  6 },
  ],
}
